import React, { Component, PropTypes } from 'react';
import {reduxForm} from "redux-form";
import {GetForingLang, GetPackages, AddCoupon, GetCouponOne, EditCoupon} from '../../actions/index';
import {Link} from 'react-router';
import _ from 'lodash';

class CouponEdit extends Component {
    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props){
        super(props);
        this.state = {
            edit: false
        }
        this.delCoupon = this.delCoupon.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.chooseFunc = this.chooseFunc.bind(this);
        this.renderSelect = this.renderSelect.bind(this);
        this.getPackageSelect = this.getPackageSelect.bind(this);
        this.chooseEdit = this.chooseEdit.bind(this);
        this.removeMinus = this.removeMinus.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetForingLang(token);
        if(this.props.params.id_coupon){
            this.props.GetCouponOne(token, this.props.params.id_coupon);
            this.renderSelect('language');
            this.setState({
                edit: true
            })
        }
    }
    componentDidMount(){

    }
    delCoupon(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelCoupon(this.props.params.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.context.router.push('/admins');
            }
        });
    }
    delCouponOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        $('#DelCoupon').modal('show');
    }
    closeModal(){
        $('#DelCoupon').modal('hide');
    }
    SubmitForm(props){
        let token = localStorage.getItem('id_token_admin');
        if($('select.plan').val() == '' || $('select.plan').val() == 'selectDefault' || $('select.plan').val() == null){
            $('select.plan').closest('.col-md-4').addClass('has-error');
        }
        props.plan = $('select.plan').val();
        props.flang = parseInt(props.language);
        delete props.language;
        delete props.planOne;
        if($('.addCoupon').find('.has-error').length > 0){
            return false
        }else{
            if(this.props.params.id_coupon){
                props.plan = JSON.parse("[" + props.plan + "]");
                this.props.EditCoupon(token, props, this.props.params.id_coupon).then((response)=>{
                    if(response.payload.status == 200){
                        this.context.router.push('/subscription/coupons');
                    }
                });
            }else{
                props.plan = JSON.parse("[" + props.plan + "]");
                this.props.AddCoupon(token, props).then((response)=>{
                    if(response.payload.status == 201){
                        this.context.router.push('/subscription/coupons');
                    }else{
                        $('.error-paragraf').show();
                    }
                });
            }
        }
    }
    chooseFunc(e){
        let element = e.target;
        this.props.fields[e.target.name].onChange(e.target.value);
        this.renderSelect('language');
        if(e.target.value == 'false'){
            setTimeout(()=>{
                $('body').find('.selectpicker').selectpicker();
            }, 500)
        }else{
            $('body').find('.selectpicker').selectpicker('destroy');
        }
    }
    renderSelect(id){
        let that = this;
        if(this.props.lang.foring_lang.results instanceof Array){
            this.props.lang.foring_lang.results.forEach((item)=>{
                if($('#'+id).find("option#"+item.id).length){
                    return false
                }else{
                    $('#'+id).append($('<option>', {
                        value: item.id,
                        text : item.lang.name,
                        id : item.id
                    }));
                }
            });

            $('.datapickers').datepicker({
                language: 'en',
                format: "yyyy-mm-dd",
                autoclose: true
            }).on('hide', function(e){
                let  dateObject = $(this).val();
                that.props.fields[e.target.name].onChange(dateObject);
                $(this).datepicker('hide');
            });

            $('#'+id).trigger('change');
        }
    }
    removeClass(e){
        $(e.target).closest('.col-md-4').removeClass('has-error');
        if(e.target.name == 'plan'){
            $('select.plan').val(e.target.value);
        }
    }
    removeMinus(e){
        let string = e.target.value.replace('-', '');
        this.props.fields[e.target.name].onChange(string);
    }
    getPackageSelect(e, id){
        let token = localStorage.getItem('id_token_admin');
        let val = e.target.value;
        this.props.fields[e.target.name].onChange(e.target.value)
        this.props.GetPackages(token, e.target.value).then((response)=>{
            $('select.plan')
                .find('option:not(#selectDefault)')
                .remove();
            response.payload.data.results.forEach((item)=>{
                let one_item = _.findWhere(item.translations, {blang: parseInt(val)});
                if(one_item === undefined){
                    one_item = _.findWhere(item.translations, 1);
                    if(_.findWhere(item.translations, 1)) {
                        if ($('select.plan').find("option#" + one_item.id).length) {
                            return false
                        } else {
                            $('select.plan').append($('<option>', {
                                value: item.id,
                                text: one_item.title,
                                id: one_item.title
                            }));
                        }
                    }
                }else{
                    if(_.findWhere(item.translations, {blang: parseInt(val)})) {
                        if ($('select.plan').find("option#" + one_item.id).length) {
                            return false
                        } else {
                            $('select.plan').append($('<option>', {
                                value: item.id,
                                text: one_item.title,
                                id: one_item.title
                            }));
                        }
                    }
                }
            });
            if(this.props.fields.is_corporate.value == 'false'){
                $('body').find('.selectpicker').selectpicker('refresh');
            }else{
                $('body').find('.selectpicker').selectpicker('destroy');
            }

        });
    }
    componentWillUnmount(){
        this.props.subscription.coupon_one = {};
    }
    chooseEdit(lang, id){
        let token = localStorage.getItem('id_token_admin');
        setTimeout(()=>{
            this.props.fields.language.onChange(lang);
            let val = lang;
            this.props.GetPackages(token, lang).then((response)=>{
                $('select.plan').find('option:not(#selectDefault)').remove();
                response.payload.data.results.forEach((item)=>{
                    let one_item = _.findWhere(item.translations, {blang: parseInt(val)});
                    if(_.findWhere(item.translations, {blang: parseInt(val)})) {
                        if ($('select.plan').find("option#" + one_item.id).length) {
                            return false
                        } else {
                            $('select.plan').append($('<option>', {
                                value: item.id,
                                text: one_item.title,
                                id: one_item.title
                            }));
                        }
                    }
                });
                if(is_corporate){
                    $('select.plan').val(id);
                }else{
                    $('select.plan').val(id[0]);
                }
                if(this.props.fields.is_corporate.value == 'false'){
                    $('body').find('.selectpicker').selectpicker('refresh');
                }else{
                    $('body').find('.selectpicker').selectpicker('destroy');
                }

            });
        }, 500)
        this.setState({
            edit: false
        })
    }
    render() {
        const { fields: {
            coupon_code,
            is_corporate,
            discount,
            language,
            plan,
            max_usages,
            planOne,
            expiration_date}, handleSubmit} = this.props;
        if(this.state.edit && this.props.lang.foring_lang.results && this.props.params.id_coupon && language.value != 'selectDefault' && planOne.value != undefined && planOne.value.length > 0){
            this.chooseEdit(language.value, planOne.value);
        }
        return (
            <div className="dashboard-wrapper">
                {this.props.params.id_coupon && this.props.subscription.coupon_one ? <p className="dashboard-title">{this.props.subscription.coupon_one.coupon_code}</p> : <p className="dashboard-title">Add Coupon</p>}
                <form className="addCoupon" onSubmit={handleSubmit(this.SubmitForm.bind(this))}>
                    <div className="col-md-12">
                        <div className="white-block block-4-8 clearfix">
                            <div className='clearfix'>
                                <div className="col-md-4">
                                    <label htmlFor="study_type">Coupon</label>
                                </div>
                                <div className='col-md-4'>
                                    <select className="form-control" name="is_corporate" id="is_corporate" disabled={is_corporate.initialValue != 'select' ? 'disabled' : ''} {...is_corporate} onChange={this.chooseFunc}>
                                        <option value="select">Select coupon type</option>
                                        <option value="false">Normal</option>
                                        <option value="true">Enterprise</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {is_corporate.value != 'select' ?
                            <div className="white-block block-4-8 clearfix">
                                <div>
                                    <div className='clearfix'>
                                        <div className="col-md-4">
                                            <label htmlFor="phrase">Coupon code</label>
                                        </div>
                                        <div className={ coupon_code.touched && !coupon_code.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                            <input className="form-control"
                                                   name="coupon_code"
                                                   id="coupon_code"
                                                   {...coupon_code}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='clearfix'>
                                        <div className="col-md-4">
                                            <label htmlFor="phrase">Discount percentage</label>
                                        </div>
                                        <div className={ discount.touched && !discount.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                            <input className="form-control"
                                                   name="discount"
                                                   id="discount"
                                                   type="number"
                                                   min="0"
                                                   max="100"
                                                   {...discount}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='clearfix'>
                                        <div className="col-md-4">
                                            <label htmlFor="phrase">Language</label>
                                        </div>
                                        <div className={ language.touched && !language.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                            <select className="form-control" name="language" id="language" {...language} onChange={this.getPackageSelect}>
                                                <option value="selectDefault">Choose language</option>
                                                {this.props.lang.foring_lang.results ? this.renderSelect('language') : ""}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    {is_corporate.value == 'false' ?
                                        <div className='clearfix'>
                                            <div className="col-md-4">
                                                <label htmlFor="plan2">Packages</label>
                                            </div>
                                            <div className='col-md-4'>
                                                <select className="selectpicker plan" name="plan2" id="plan2" defaultValue={planOne.value} multiple='multile'
                                                        data-live-search="true" onChange={this.removeClass}>
                                                    <option id="selectDefault" value="selectDefault">Choose package
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        :
                                        <div className='clearfix'>
                                            <div className="col-md-4">
                                                <label htmlFor="plan">Packages</label>
                                            </div>
                                            <div className='col-md-4'>
                                                <select className="form-control plan" name="plan" id="plan" defaultValue={planOne.value != undefined && planOne.value.length > 0 ? planOne.value[0] : ''} onChange={this.removeClass}>
                                                    <option value="selectDefault" id="selectDefault">Choose package
                                                    </option>
                                                </select>
                                            </div>

                                        </div>
                                    }
                                </div>
                                <div>
                                    <div className='clearfix'>
                                        <div className="col-md-4">
                                            <label htmlFor="phrase">Number of learners</label>
                                        </div>
                                        <div className={ max_usages.touched && !max_usages.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                            <input className="form-control"
                                                   name="max_usages"
                                                   id="max_usages"
                                                   type="number"
                                                   min="0"
                                                   {...max_usages}
                                                   onChange={this.removeMinus}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className='clearfix'>
                                        <div className="col-md-4">
                                            <label htmlFor="phrase">Expiry date</label>
                                        </div>
                                        <div className={ expiration_date.touched && !expiration_date.valid ? 'col-md-4 has-error': 'col-md-4'}>
                                            <input className="form-control datapickers"
                                                   name="expiration_date"
                                                   id="expiration_date"
                                                   {...expiration_date}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            ""
                        }

                    </div>
                    <div className="col-md-12">
                        <div className="white-block clearfix">
                            <div className="col-md-12 text-center button-group">
                                <p className="error-paragraf">Coupon number already exists</p>
                                <Link to={"subscription/coupons/"} className="btn btn-default">Cancel</Link>
                                {is_corporate.value != 'select' ? <button type="submit" className="btn btn-primary">Save</button> : ""}
                            </div>
                        </div>
                    </div>
                </form>

                <div className="modal fade" id="DelCoupon" tabIndex="-1" role="dialog" aria-labelledby="DelCouponLabel">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body text-center">
                                <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelCoupon"></span>
                                <p>Do you really want to delete coupon ?</p>
                            </div>
                            <div className="modal-footer text-center">
                                <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                <button onClick={this.delCoupon} type="button" className="btn btn-primary">Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}
// {this.props.admins.admin_one ? <span>{this.props.admins.admin_one.first_name} {this.props.admins.admin_one.last_name}</span> : ""}
// {this.state.study_type != 'select' || study_type.initialValue != 'select' ? <button type="submit" className="btn btn-primary">Save</button> : ""}
function validate(values) {
    const errors = {};
    if(!values.discount || Number(values.discount) >101){
        errors.discount = 'Enter a title'
    }
    if(!values.is_corporate){
        errors.is_corporate = 'Enter a title'
    }
    if(!values.coupon_code){
        errors.coupon_code = 'Enter a title'
    }
    if(!values.max_usages){
        errors.max_usages = 'Enter a title'
    }
    if(!values.expiration_date){
        errors.expiration_date = 'Enter a title'
    }
    if(!values.language || values.language == 'selectDefault'){
        errors.language = 'Enter a title'
    }
    return errors;
}

function  mapStateToProps(state) {
    let planOneProp = [];
    if(state.subscription.coupon_one && state.subscription.coupon_one.plan){
        state.subscription.coupon_one.plan.forEach((item)=>{
            planOneProp.push(item.id)
        });
    }
    return{
        lang: state.lang,
        subscription: state.subscription,
        initialValues: {
            is_corporate: state.subscription.coupon_one.is_corporate != undefined ? state.subscription.coupon_one.is_corporate.toString() : 'select',
            discount: state.subscription.coupon_one.discount || '',
            coupon_code: state.subscription.coupon_one.coupon_code || '',
            max_usages: state.subscription.coupon_one.max_usages || '',
            expiration_date: state.subscription.coupon_one.expiration_date || '',
            language: state.subscription.coupon_one.flang != undefined ?  state.subscription.coupon_one.flang.toString() : 'selectDefault',
            planOne: planOneProp ? planOneProp : 'selectDefault'
        }
    }
}
export default reduxForm({
    form: 'Edit Coupon',
    fields: ['is_corporate', 'discount', 'coupon_code', 'language', 'plan', 'max_usages', 'expiration_date', 'planOne'],
    validate
}, mapStateToProps, {GetForingLang, GetPackages, AddCoupon, GetCouponOne, EditCoupon})(CouponEdit);



// WEBPACK FOOTER //
// ./src/components/subscription/CouponsEdit.js